//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    noticeData: {
      type: Object,
      default: () => ({})
    }
  }
}
